module.exports = __webpack_public_path__ + "img/attachments.b796a6c6.png";